import {
  ACCESS_DENIED_PATH,
  ERROR_PATH,
  NO_PERMISSION_PATH,
  NOT_FOUND_PATH,
  SIGNIN_PATH
} from '@/constants'

const MainPage = () => import('@/views/MainPage.vue')

/**
 * Authenticated page routes (MainPage layout).
 * Route names MUST match the menu `name` column in the database so that
 * hasMenuAccess() can verify the user's role grants access to each page.
 */
const authenticatedRoutes = [
  {
    path: '/',
    component: MainPage,
    children: [
      { path: '', name: 'home', component: () => import('@/views/home/HomePage.vue'), meta: { protected: true, title: 'router.home' } },
      { path: '/app', name: 'app', component: () => import('@/views/app/AppPage.vue'), meta: { protected: true, title: 'router.app_main' } },
      { path: '/module', name: 'module', component: () => import('@/views/module/ModulePage.vue'), meta: { protected: true, title: 'router.module_main' } },
      { path: '/resource', name: 'resource', component: () => import('@/views/resource/ResourcePage.vue'), meta: { protected: true, title: 'router.resource_main' } },
      { path: '/operation', name: 'operation', component: () => import('@/views/operation/OperationPage.vue'), meta: { protected: true, title: 'router.operation_main' } },
      { path: '/permission', name: 'permission', component: () => import('@/views/permission/PermissionPage.vue'), meta: { protected: true, title: 'router.permission_main' } },
      { path: '/menu-group', name: 'menu-group', component: () => import('@/views/menuGroup/MenuGroupPage.vue'), meta: { protected: true, title: 'router.menu_group_main' } },
      { path: '/menu-item', name: 'menu-item', component: () => import('@/views/menuItem/MenuItemPage.vue'), meta: { protected: true, title: 'router.menu_item_main' } },
      { path: '/user', name: 'user', component: () => import('@/views/user/UserPage.vue'), meta: { protected: true, title: 'router.user_main' } },
      { path: '/role', name: 'role', component: () => import('@/views/role/RolePage.vue'), meta: { protected: true, title: 'router.role_main' } },
      { path: '/group', name: 'group', component: () => import('@/views/group/GroupPage.vue'), meta: { protected: true, title: 'router.group_main' } },
      { path: '/system-log', name: 'system-log', component: () => import('@/views/systemLog/SystemLogPage.vue'), meta: { protected: true, title: 'router.system_log_main' } },
      { path: '/system-config', name: 'system-config', component: () => import('@/views/systemConfig/SystemConfigPage.vue'), meta: { protected: true, title: 'router.system_config_main' } },
      { path: '/zt-network', name: 'zt-network', component: () => import('@/views/ztNetwork/ZtNetworkPage.vue'), meta: { protected: true, title: 'ZeroTier Networks' } },
      { path: '/zt-network/:networkId', name: 'zt-network-detail', component: () => import('@/views/ztNetwork/ZtNetworkDetailPage.vue'), meta: { protected: true, title: 'Network Detail' } },
      { path: '/zt-instance', name: 'zt-instance', component: () => import('@/views/ztInstance/ZtInstancePage.vue'), meta: { protected: true, title: 'router.zt_instance_main' } },
      { path: '/zt-instruction', name: 'zt-instruction', component: () => import('@/views/ztInstruction/ZtInstructionPage.vue'), meta: { protected: true, title: 'router.zt_instruction_main' } },
      { path: '/profile', name: 'profile', component: () => import('@/views/profile/ProfilePage.vue'), meta: { protected: true, title: 'profile.title' } },
    ]
  }
]

const staticRoutes = [
  ...authenticatedRoutes,
  {
    path: SIGNIN_PATH,
    component: () => import('@/views/SigninPage.vue'),
    name: 'signin',
    meta: { title: 'signin.signin' }
  },
  {
    path: '/other',
    component: () => import('@/views/MainOtherPage.vue'),
    children: [
      { path: ACCESS_DENIED_PATH, component: () => import('@/views/403.vue'), meta: { title: 'router.access_denied' } },
      { path: NO_PERMISSION_PATH, name: 'no-permission', component: () => import('@/views/NoPermissionPage.vue'), meta: { title: 'router.no_permission' } },
      { path: NOT_FOUND_PATH, component: () => import('@/views/404.vue'), meta: { title: 'router.not_found' } },
      { path: ERROR_PATH, name: 'error', component: () => import('@/views/ErrorPage.vue'), meta: { title: 'router.error' } }
    ]
  }
]

const catchAllRoute = {
  path: '/:pathMatch(.*)*',
  redirect: { path: NOT_FOUND_PATH }
}

/**
 * Route names that are always accessible to any authenticated user
 * without requiring a menu_role entry in the database.
 */
const openRouteNames: ReadonlySet<string> = new Set([
  'home',
  'profile',
  'zt-network-detail',
])

export { staticRoutes, catchAllRoute, openRouteNames }
